/*
 * fn: renderTemplate
 *
 * Renders a template React Node given replacements
 *
 */
import { cloneElement, isValidElement, type ReactNode } from 'react'

export const renderTemplate = (template: string, render: (type?: string, value?: string) => ReactNode) => {
  const parts: ReactNode[] = []
  let i = 0
  let lastIndex = 0

  const regex = /\{\{([^}]+)\}\}/g
  let match: RegExpExecArray | null

  while ((match = regex.exec(template)) !== null) {
    const [fullMatch, inner] = match
    const [type, value] = inner?.split('|') || []

    if (match.index > lastIndex) parts.push(<span key={i++}>{template.slice(lastIndex, match.index)}</span>)

    const node = render(type, value)
    if (isValidElement(node)) {
      parts.push(cloneElement(node, { key: i++ }))
    } else {
      parts.push(node)
      i++
    }

    lastIndex = match.index + fullMatch.length
  }

  if (lastIndex < template.length) parts.push(<span key={i}>{template.slice(lastIndex)}</span>)

  return parts
}
